function Hero() {
  return (
    <section id="top" className="relative isolate flex min-h-[640px] items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20warm%20anime%20illustration%20of%20an%20open%20manga%20book%20with%20glowing%20pages%20flipping%20through%20the%20air%2C%20floating%20paper%20sheets%20with%20soft%20motion%20trails%2C%20coral%20orange%20and%20golden%20amber%20lighting%2C%20cozy%20cream%20reading%20atmosphere%2C%20warm%20dreamy%20background%2C%20painterly%20art%20style%2C%20high%20detail%2C%20cinematic%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=hero-flip-2026&orientation=landscape"
        alt="哔咔漫画翻页音效体验背景插画，暖色纸页在空中翻动"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-background-950/70"></div>
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-background-50 to-transparent"></div>

      <div className="relative mx-auto w-full max-w-7xl px-4 pb-24 pt-28 md:px-6">
        <div className="max-w-3xl">
          <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs text-background-50 backdrop-blur-sm md:text-sm">
            <i className="ri-sound-module-line"></i>
            翻页音效 · 翻页动画 · 纸感阅读
          </span>
          <h1 className="font-heading text-4xl leading-tight text-background-50 md:text-6xl">
            翻一页，听见纸的声音
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
            哔咔漫画翻页音效专区收录真实拾音的翻页声，配合 GPU 加速的流畅翻页动画，
            高度还原纸质漫画的沉浸阅读体验。打开哔咔漫画，感受每一页翻动带来的声画反馈，
            追更热门漫画更带感。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#sound"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-7 py-3.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400"
            >
              <i className="ri-play-circle-line text-lg"></i>
              体验翻页音效
            </a>
            <a
              href="#flip"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-7 py-3.5 text-sm font-semibold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
            >
              <i className="ri-stack-line text-lg"></i>
              查看翻页动画
            </a>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4">
          {[
            { icon: "ri-vip-crown-line", num: "12万+", label: "热门漫画" },
            { icon: "ri-sound-module-line", num: "60+", label: "翻页音效" },
            { icon: "ri-flashlight-line", num: "4K", label: "高帧率动画" },
            { icon: "ri-user-smile-line", num: "8000万", label: "阅读爱好者" },
          ].map((s) => (
            <div
              key={s.label}
              className="rounded-xl border border-background-50/20 bg-background-950/25 p-4 backdrop-blur-sm"
            >
              <i className={`${s.icon} text-xl text-accent-400`}></i>
              <p className="mt-2 text-xl font-bold text-background-50 md:text-2xl">{s.num}</p>
              <p className="text-xs text-background-200/80 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Hero;